import PropTypes from "prop-types"
import React, { useState } from "react"

import Button from "src/components/Button"
import InlineNotice from "src/components/InlineNotice"
import Modal from "src/components/Modal"

const ContactLinkIssueNotice = ({
  contactEmail,
  accountEmail,
  message,
  contactEmailLabel,
  accountEmailLabel,
  fixButtonLabel,
  fixFormId,
  confirmTitle,
  confirmMessage,
  cancelLabel,
  archivedMessage,
}) => {
  const [confirming, setConfirming] = useState(false)

  return (
    <InlineNotice
      variant="warning"
      icon="fa-triangle-exclamation"
      iconStyle="solid"
    >
      <p className="mb-2">{message}</p>
      <dl className="mb-0 grid grid-cols-[auto_1fr] gap-x-2 gap-y-1">
        <dt className="font-semibold">{contactEmailLabel}</dt>
        <dd className="mb-0 break-all">{contactEmail}</dd>
        <dt className="font-semibold">{accountEmailLabel}</dt>
        <dd className="mb-0 break-all">{accountEmail}</dd>
      </dl>
      {fixFormId && (
        <div className="mt-3">
          <Button
            type="button"
            variant="secondary"
            small
            onClick={() => setConfirming(true)}
          >
            {fixButtonLabel}
          </Button>
        </div>
      )}
      {archivedMessage && <p className="mb-0 mt-3">{archivedMessage}</p>}
      {confirming && (
        <Modal isOpen onClose={() => setConfirming(false)} size="small" stacked>
          <Modal.Header title={confirmTitle} />
          <Modal.Body>
            <p>{confirmMessage}</p>
          </Modal.Body>
          <Modal.Footer
            onClose={() => setConfirming(false)}
            cancelBtnText={cancelLabel}
            confirmBtnText={fixButtonLabel}
            confirmBtnType="submit"
            confirmBtnForm={fixFormId}
          />
        </Modal>
      )}
    </InlineNotice>
  )
}

ContactLinkIssueNotice.propTypes = {
  contactEmail: PropTypes.string.isRequired,
  accountEmail: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  contactEmailLabel: PropTypes.string.isRequired,
  accountEmailLabel: PropTypes.string.isRequired,
  fixButtonLabel: PropTypes.string.isRequired,
  fixFormId: PropTypes.string,
  confirmTitle: PropTypes.string,
  confirmMessage: PropTypes.string,
  cancelLabel: PropTypes.string,
  archivedMessage: PropTypes.string,
}

export default ContactLinkIssueNotice
